import React from "react";
import SeoHead from "../../../../components/SeoHead";
import EventOrganizersHero from "../event-organizers/EventOrganizersHero";
import SmartPlatform from "../event-organizers/SmartPlatform";
import PaymentStruggles from "../event-organizers/PaymentStruggles";
import WhyOrganizersLove from "../event-organizers/WhyOrganizersLove";
import HowNdovuWorks from "../event-organizers/HowNdovuWorks";
import { contractorsConfig as config } from "../serviceConfig";

function Contractors() {
  return (
    <div id="contractors">
      <SeoHead title="Contractors" description="Pay construction crews fast and track every project cost. No cash handling, no leakages — manage all site payments from one dashboard." path="/services/contractors" />
      <EventOrganizersHero hero={config.hero} />
      <SmartPlatform platform={config.platform} />
      <PaymentStruggles struggles={config.struggles} /> 
      <HowNdovuWorks how={config.how} />
      <WhyOrganizersLove why={config.why} />
    </div>
  );
}

export default Contractors;
